/**
 * Submission Mapper Module
 * Handles the submission mapper queue interface
 */
class SubmissionMapper {
  static EL_PAGE = '#submission_mapper_page';

  constructor() {
    this.selectedSubmissions = new Set();
    this.processingStatuses = new Map();
    this.statusCheckInterval = null;

    this.init();
  }

  /**
   * Initialize the submission mapper
   */
  init() {
    console.log('=== INITIALIZING SUBMISSION MAPPER ===');
    console.log('Preview buttons found:', $('.preview-btn').length);
    console.log('CardModal available:', typeof window.CardModal);

    // Set up event listeners
    this.setupEventListeners();

    // Start status polling
    this.startStatusPolling();

    console.log('Submission Mapper initialized');
  }

  /**
   * Set up all event listeners
   */
  setupEventListeners() {
    const self = this;

    // Select all checkbox
    $('#select-all-checkbox').on('change', function() {
      const isChecked = $(this).prop('checked');
      $('.submission-checkbox').prop('checked', isChecked);
      self.updateSelectedCount();
    });

    // Individual checkboxes
    $('.submission-checkbox').on('change', function() {
      self.updateSelectedCount();
    });

    // Select all button
    $('#select-all-btn').on('click', function() {
      $('#select-all-checkbox').prop('checked', true).trigger('change');
    });

    // Bulk process button
    $('#bulk-process-btn').on('click', function() {
      self.bulkProcess();
    });

    // Preview buttons - just navigate to preview page
    $('.preview-btn').on('click', function(e) {
      const submissionId = $(this).data('id');
      window.location.href = `/submission-mapper-queue/preview/${submissionId}`;
    });

    // Process buttons
    $('.process-btn').on('click', function() {
      const submissionId = $(this).data('id');
      self.processSubmission(submissionId);
    });

    // Reject buttons
    $('.reject-btn').on('click', function() {
      const submissionId = $(this).data('id');
      self.rejectSubmission(submissionId);
    });
  }

  /**
   * Update the count of selected submissions
   */
  updateSelectedCount() {
    const count = $('.submission-checkbox:checked').length;
    $('#selected-count').text(count);
    $('#bulk-process-btn').prop('disabled', count === 0);
  }

  /**
   * Process a submission
   */
  processSubmission(submissionId) {
    console.log('[SubmissionMapper] processSubmission called with ID:', submissionId);
    const self = this;
    const $button = $(`.process-btn[data-id="${submissionId}"]`);
    const $row = $button.closest('tr');
    console.log('[SubmissionMapper] Button found:', $button.length, 'Row found:', $row.length);

    if (!confirm('Process this submission?\n\nThis will create/update account and create a new title.')) {
      console.log('[SubmissionMapper] User cancelled');
      return;
    }
    console.log('[SubmissionMapper] User confirmed, starting processing');

    // Disable button and show spinner
    $button.prop('disabled', true).html('<i class="fas fa-spinner fa-spin"></i> Processing...');

    // Update status badge
    this.updateStatusBadge(submissionId, 'processing', 'Processing...');

    // Call API to process submission SYNCHRONOUSLY
    $.ajax({
      url: `/api/submissions/${submissionId}/process`,
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({
        async: false, // Process immediately, don't queue
      }),
      dataType: 'json',
      timeout: 120000, // 2 minute timeout for long operations
      success: function(response) {
        if (response.success && response.data) {
          const result = response.data;

          // Show success message with title link
          const titleUrl = result.title_url || `/title/${result.title_id}`;
          const autoApproved = result.title_auto_approved ? ' (Auto-approved)' : '';

          self.showNotification(
            `✓ Submission processed successfully!<br>` +
            `Account ID: ${result.account_id}${result.account_created ? ' (New)' : ' (Existing)'}<br>` +
            `Title ID: <a href="${titleUrl}" style="color: white; text-decoration: underline;">${result.title_id}</a>${autoApproved}`,
            'success'
          );

          self.updateStatusBadge(submissionId, 'completed', 'Completed');

          // Remove row after brief delay
          setTimeout(function() {
            $row.fadeOut(300, function() {
              $(this).remove();
            });
          }, 2000);
        } else {
          self.showNotification('Error: ' + (response.error || 'Unknown error'), 'alert');
          $button.prop('disabled', false).html('<i class="fas fa-cogs"></i> Process');
          self.updateStatusBadge(submissionId, 'error', 'Error');
        }
      },
      error: function(xhr) {
        const errorMsg = xhr.responseJSON && xhr.responseJSON.error ? xhr.responseJSON.error : 'Failed to process';
        self.showNotification('Error: ' + errorMsg, 'alert');
        $button.prop('disabled', false).html('<i class="fas fa-cogs"></i> Process');
        self.updateStatusBadge(submissionId, 'error', 'Error');
      },
    });
  }

  /**
   * Reject a submission
   */
  rejectSubmission(submissionId) {
    const self = this;
    const reason = prompt('Enter rejection reason (optional):');

    if (reason === null) {
      return; // User cancelled
    }

    const $button = $(`.reject-btn[data-id="${submissionId}"]`);

    $button.prop('disabled', true).html('<i class="fas fa-spinner fa-spin"></i>');

    $.ajax({
      url: `/api/submissions/${submissionId}/reject`,
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({
        reason: reason || 'No reason provided',
      }),
      dataType: 'json',
      success: function(response) {
        if (response.success) {
          self.showNotification('Submission rejected', 'warning');

          // Remove row from table
          $button.closest('tr').fadeOut(300, function() {
            $(this).remove();
          });
        } else {
          self.showNotification('Error: ' + (response.error || 'Unknown error'), 'alert');
          $button.prop('disabled', false).html('<i class="fas fa-times"></i>');
        }
      },
      error: function() {
        self.showNotification('Error: Failed to reject submission', 'alert');
        $button.prop('disabled', false).html('<i class="fas fa-times"></i>');
      },
    });
  }

  /**
   * Bulk process selected submissions
   */
  bulkProcess() {
    const self = this;
    const submissionIds = [];

    $('.submission-checkbox:checked').each(function() {
      submissionIds.push($(this).val());
    });

    if (submissionIds.length === 0) {
      return;
    }

    if (!confirm(`Process ${submissionIds.length} submissions?\n\nThis will create/update accounts and create titles.`)) {
      return;
    }

    const $button = $('#bulk-process-btn');
    $button.prop('disabled', true).html('<i class="fas fa-spinner fa-spin"></i> Processing...');

    $.ajax({
      url: '/api/submissions/bulk-process',
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({
        submission_ids: submissionIds,
      }),
      dataType: 'json',
      success: function(response) {
        if (response.success) {
          const results = response.results;
          const queuedCount = results.queued.length;
          const alreadyProcessingCount = results.already_processing.length;
          const errorCount = results.errors.length;

          self.showNotification(
            `Bulk processing initiated: ${queuedCount} queued, ${alreadyProcessingCount} already processing, ${errorCount} errors`,
            'success',
          );

          // Mark as processing
          results.queued.forEach(function(id) {
            self.processingStatuses.set(id, true);
            self.updateStatusBadge(id, 'processing', 'Processing...');
          });

          // Uncheck all
          $('.submission-checkbox').prop('checked', false);
          $('#select-all-checkbox').prop('checked', false);
          self.updateSelectedCount();

          $button.prop('disabled', false).html('<i class="fas fa-cogs"></i> Process Selected (<span id="selected-count">0</span>)');
        } else {
          self.showNotification('Error: ' + (response.error || 'Unknown error'), 'alert');
          $button.prop('disabled', false).html('<i class="fas fa-cogs"></i> Process Selected (<span id="selected-count">0</span>)');
        }
      },
      error: function() {
        self.showNotification('Error: Failed to bulk process', 'alert');
        $button.prop('disabled', false).html('<i class="fas fa-cogs"></i> Process Selected (<span id="selected-count">0</span>)');
      },
    });
  }

  /**
   * Update status badge for a submission
   */
  updateStatusBadge(submissionId, status, text) {
    const $badge = $(`.processing-status-badge[data-submission-id="${submissionId}"]`);

    const labelClass =
      {
        processing: 'warning',
        completed: 'success',
        error: 'alert',
        ready: 'secondary',
      }[status] || 'secondary';

    const icon =
      {
        processing: 'spinner fa-spin',
        completed: 'check',
        error: 'exclamation-triangle',
        ready: 'clock',
      }[status] || 'clock';

    $badge.html(`<span class="label ${labelClass}"><i class="fas fa-${icon}"></i> ${text}</span>`);
  }

  /**
   * Poll submission status until complete
   */
  pollSubmissionStatus(submissionId) {
    const self = this;
    let attempts = 0;
    const maxAttempts = 60; // 5 minutes (5-second intervals)

    const checkStatus = function() {
      attempts++;

      $.ajax({
        url: `/api/submissions/${submissionId}/status`,
        method: 'GET',
        dataType: 'json',
        success: function(response) {
          if (response.success && response.data) {
            const isProcessing = response.data.is_processing;
            const result = response.data.result;

            if (!isProcessing && result) {
              // Processing complete
              self.processingStatuses.delete(submissionId);

              if (result.success === false) {
                // Error
                self.updateStatusBadge(submissionId, 'error', 'Failed');
                self.showNotification(`Submission ${submissionId} failed: ${result.error}`, 'alert');
              } else {
                // Success
                self.updateStatusBadge(submissionId, 'completed', 'Completed');
                self.showNotification(
                  `Submission ${submissionId} processed successfully! Title ID: ${result.title_id}`,
                  'success',
                );

                // Remove row after brief delay
                setTimeout(function() {
                  $(`tr[data-submission-id="${submissionId}"]`).fadeOut(300, function() {
                    $(this).remove();
                  });
                }, 2000);
              }
            } else if (attempts < maxAttempts) {
              // Still processing, check again
              setTimeout(checkStatus, 5000);
            } else {
              // Max attempts reached
              self.updateStatusBadge(submissionId, 'error', 'Timeout');
              self.showNotification(`Submission ${submissionId} timed out. Check logs for details.`, 'warning');
            }
          }
        },
        error: function() {
          if (attempts < maxAttempts) {
            setTimeout(checkStatus, 5000);
          }
        },
      });
    };

    // Start checking
    setTimeout(checkStatus, 5000);
  }

  /**
   * Start polling for status updates of processing submissions
   */
  startStatusPolling() {
    const self = this;

    // Check every 10 seconds for any processing submissions
    this.statusCheckInterval = setInterval(function() {
      if (self.processingStatuses.size > 0) {
        self.processingStatuses.forEach(function(value, submissionId) {
          // Only poll if still marked as processing
          if (value) {
            self.pollSubmissionStatus(submissionId);
          }
        });
      }
    }, 10000);
  }

  /**
   * Show notification toast
   */
  showNotification(message, type) {
    // Use Foundation Callout for notifications
    const calloutClass = type || 'primary';
    const $callout = $(`
            <div class="callout ${calloutClass}" style="position: fixed; top: 20px; right: 20px; z-index: 9999; max-width: 400px;">
                ${message}
                <button class="close-button" aria-label="Dismiss alert" type="button">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        `);

    $('body').append($callout);

    // Manual close button handler
    $callout.find('.close-button').on('click', function() {
      $callout.fadeOut(300, function() {
        $(this).remove();
      });
    });

    // Auto-close after 5 seconds
    setTimeout(function() {
      $callout.fadeOut(300, function() {
        $(this).remove();
      });
    }, 5000);
  }
}

// Make processSubmission available globally for modal
window.SubmissionMapper = {
  instance: null,
  processSubmission: function(submissionId) {
    if (this.instance && this.instance.processSubmission) {
      this.instance.processSubmission(submissionId);
    }
  },
};

// Initialize submission mapper when DOM is ready
;(function() {
  function initMapper() {
    if (document.querySelector(SubmissionMapper.EL_PAGE) !== null) {
      const mapper = new SubmissionMapper();
      window.sflow.submissionMapper = mapper;
      window.SubmissionMapper.instance = mapper;
    }
  }

  // Initialize immediately if DOM is already loaded, otherwise wait for DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMapper);
  } else {
    initMapper();
  }
})();
